export enum MobileAppType {
  timeSwift = 1
}
